export default __webpack_public_path__ + "static/media/Ct12.53f62869.png";